import { render, staticRenderFns } from "./phoria.config.vue?vue&type=template&id=427a682c"
import script from "./phoria.config.vue?vue&type=script&lang=js"
export * from "./phoria.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports